/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAssistantExecutionProfilesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAssistantExecutionProfilesRequest = {
  /**
   * The assistant ID.
   */
  assistantId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListAssistantExecutionProfilesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAssistantExecutionProfilesSecurity$outboundSchema:
  z.ZodMiniType<
    ListAssistantExecutionProfilesSecurity$Outbound,
    ListAssistantExecutionProfilesSecurity
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listAssistantExecutionProfilesSecurityToJSON(
  listAssistantExecutionProfilesSecurity:
    ListAssistantExecutionProfilesSecurity,
): string {
  return JSON.stringify(
    ListAssistantExecutionProfilesSecurity$outboundSchema.parse(
      listAssistantExecutionProfilesSecurity,
    ),
  );
}

/** @internal */
export type ListAssistantExecutionProfilesRequest$Outbound = {
  assistant_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListAssistantExecutionProfilesRequest$outboundSchema:
  z.ZodMiniType<
    ListAssistantExecutionProfilesRequest$Outbound,
    ListAssistantExecutionProfilesRequest
  > = z.pipe(
    z.object({
      assistantId: z.string(),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        assistantId: "assistant_id",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
      });
    }),
  );

export function listAssistantExecutionProfilesRequestToJSON(
  listAssistantExecutionProfilesRequest: ListAssistantExecutionProfilesRequest,
): string {
  return JSON.stringify(
    ListAssistantExecutionProfilesRequest$outboundSchema.parse(
      listAssistantExecutionProfilesRequest,
    ),
  );
}
